export enum Entity {
  TAKAFUL = 'takaful',
  INSURANCE = 'insurance',
}
